export default {
  text: '#1a1a1a',
  primary: '#000',
  secondary: '#000',
  background: '#fdfdfd',
  backgroundSecondary: 'lightgrey',
  light: '#fdfdfd',
  dark: '#020303'
}
